import { Match } from 'effect';
export const LineItemService = {
    getTotalInclusiveOfInsurance: Match.type().pipe(Match.whenOr({ type: 'TeamBib' }, { type: 'SoloBib' }, ({ total, insurance }) => { var _a; return total + Math.abs((_a = insurance === null || insurance === void 0 ? void 0 : insurance.amount) !== null && _a !== void 0 ? _a : 0); }), Match.orElse((item) => item.total))
};
